import baseApi, {transformResponseFromData} from 'store/slices/api/baseApi'

const crmsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPlannerCrms: build.query({
            query: () => {
                return {
                    url: `Planner/getPlannerCrms`,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            providesTags: ['Crm'],
        }),

        savePlannerCrm: build.mutation({
            query: ({crmKey, isActive}) => {
                console.log('savePlannerCrm', {
                    crmKey: crmKey,
                    plannerCrmIsActive: isActive,
                })
                return {
                    url: 'Planner/putPlannerCrms',
                    method: 'PUT',
                    body: [
                        {
                            crmKey: crmKey,
                            plannerCrmIsActive: isActive,
                        },
                    ],
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['Crm'],
        }),
        deletePlannerCrms: build.mutation({
            query: (crms) => {
                return {
                    url: 'Planner/deletePlannerCrms',
                    method: 'DELETE',
                    body: crms,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['Note'],
        }),
    }),
    overrideExisting: false,
})

export default crmsApi

export const {
    useGetPlannerCrmsQuery,
    useSavePlannerCrmMutation,
    useDeletePlannerCrmsMutation,
} = crmsApi
